export const getSnippetByChars = (text, maxLength = 10) => {
  if (!text) return '';
  if (text.length <= maxLength) return text;

  let snippet = text.slice(0, maxLength);

  const lastSpace = snippet.lastIndexOf(' ');
  if (lastSpace > 0) {
    snippet = snippet.slice(0, lastSpace);
  }

  return snippet + '…';
};
